import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('platex_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Public
export const plateService = {
    searchByMV: (mv) => api.get(`/plates/search?mv=${mv}`),
    searchByPlate: (plate) => api.get(`/plates/search?plate=${plate}`),
};

// Admin
export const adminService = {
    login: (data) => api.post('/auth/login', data),
    verify: () => api.get('/auth/verify'),
    getAll: (q = '', page = 1, limit = 10, duplicates = '', mvExact = '', claimMatch = '', mvMatch = '') => {
        const params = new URLSearchParams({ page, limit });
        if (q) params.set('q', q);
        if (duplicates) params.set('duplicates', duplicates);
        if (mvExact) params.set('mv_exact', mvExact);
        if (claimMatch) params.set('claim_match', claimMatch);
        if (mvMatch) params.set('mv_match', mvMatch);
        return api.get(`/plates?${params.toString()}`);
    },
    getStats: (page = 1, limit = 5) => api.get(`/plates/stats/summary?page=${page}&limit=${limit}`),
    getDealers: () => api.get('/plates/dealers'),
    create: (data) => api.post('/plates', data),
    update: (id, data) => api.put(`/plates/${id}`, data),
    setClaimed: (id, is_claimed) => api.patch(`/plates/${id}/claim`, { is_claimed }),
    delete: (id) => api.delete(`/plates/${id}`),
    bulkDelete: (ids) => api.delete('/plates/bulk', { data: { ids } }),
    exportExcel: (q = '', duplicates = '', mvExact = '', claimMatch = '', mvMatch = '') => {
        const params = new URLSearchParams();
        if (q) params.set('q', q);
        if (duplicates) params.set('duplicates', duplicates);
        if (mvExact) params.set('mv_exact', mvExact);
        if (claimMatch) params.set('claim_match', claimMatch);
        if (mvMatch) params.set('mv_match', mvMatch);
        return api.get(`/plates/export?${params.toString()}`, { responseType: 'blob' });
    },
};

export const userService = {
    getAll: () => api.get('/users'),
    create: (data) => api.post('/users', data),
    update: (id, data) => api.put(`/users/${id}`, data),
    delete: (id) => api.delete(`/users/${id}`),
};

export default api;